import { render, staticRenderFns } from "./venue-events-lists.page.vue?vue&type=template&id=d463f71c&scoped=true&"
import script from "./venue-events-lists.page.vue?vue&type=script&lang=js&"
export * from "./venue-events-lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d463f71c",
  null
  
)

export default component.exports